import { render, staticRenderFns } from "./IconVouchers.vue?vue&type=template&id=117e55e1&"
import script from "./IconVouchers.vue?vue&type=script&lang=js&"
export * from "./IconVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports